import Dispatcher from "./Dispatcher";
import {
  DIVISIONS_CHOOSE,
  DIVISIONS_HOVER,
  DIVISIONS_SET_TARGET,
  GAME_PAUSE_TOGGLE,
  INITIALIZE
} from "./actionConstants";

const DO = (actionType, obj={}) => Dispatcher.dispatch(Object.assign({actionType}, obj))

export const togglePause = () => DO(GAME_PAUSE_TOGGLE)

export const setDivisionTarget = (x, y) => DO(DIVISIONS_SET_TARGET, {x, y})

export const hoverDivision = divisionId => DO(DIVISIONS_HOVER, {divisionId})

export const chooseDivision = divisionId => DO(DIVISIONS_CHOOSE, {divisionId})

export const loadBattleMap = () => DO(INITIALIZE)